export const getFormattedStringDate = string => {
  const t = new Date(string);
  return t.toLocaleString();
};
